// CMS9 added the GroupedItemsView class.

import { View } from 'ckeditor5/src/ui';

export default class GroupedItemsView extends View {
	/**
	 * Create a simple item group for nested structures.
	 *
	 * @param {module:utils/locale~Locale} locale
	 * @param {View[]} items
	 * @param {string} className
	 */
	constructor( locale, items, className ) {
		super( locale );
		this.setTemplate( {
			tag: 'div',
			attributes: {
				class: ['ck', 'ck-grouped-items-view', className || '']
			},
			children: items
		} );
	}
}
